import * as $ from "jquery";
import Vue from "vue";
import Component from "vue-class-component";
import { AbsenceClotureCreationContratDto } from "../../../dto/GenApi.iNotPaie.Dto/AbsenceClotureCreationContratDto";
import { DemandeTransfertAbsenceDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeTransfertAbsenceDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";

@Component
export default class ModalTransfertAbsencesFutures extends Vue {
    public continueProcess?: Function = undefined;
    public listeAbsences: AbsenceClotureCreationContratDto[] = [];
    public demandeTransfertAbsences: DemandeTransfertAbsenceDto | undefined;

    public init(absences: AbsenceClotureCreationContratDto[], demandeTransfert: DemandeTransfertAbsenceDto): void {
        this.listeAbsences = absences;
        this.demandeTransfertAbsences = demandeTransfert;
        $("#modalTransfertAbsencesFutures").modal("show");
    }

    public valider(): void {
        if (this.listeAbsences.length == 0 || this.listeAbsences[0].IdContrat == undefined || this.demandeTransfertAbsences == undefined)
            return;


        ServicesFactoryInstance.AbsencesService.transfererAbsences(this.demandeTransfertAbsences, () => {
            NotificationServiceInstance.SendSuccess("Les absences ont bien été transférées.");
            this.close();
        }, () => {
            NotificationServiceInstance.SendFailed("Une erreur s'est produite lors du transfert des absences.");
            this.close();
        })

    }

    public cancel(): void {
        if (this.listeAbsences[0].IdContrat == undefined)
            return;

        ServicesFactoryInstance.AbsencesService.annulerAbsencesFuturesFinDeContrat(this.listeAbsences[0].IdContrat, () => {
            NotificationServiceInstance.SendSuccess("Les absences futures ont bien été annulées.");
            this.$emit("refreshAbsences");

            this.close();
        }, () => {
            NotificationServiceInstance.SendFailed("Une erreur s'est produite lors de l'annulation des absences.");
            this.close();
        });
    }

    private close() {
        if (this.continueProcess != undefined) {
            this.continueProcess();
        }
        $("#modalTransfertAbsencesFutures").modal("hide");
    }
}



// WEBPACK FOOTER //
// ./src/components/modalComponents/modalTransfertAbsencesFutures/modalTransfertAbsencesFutures.ts